import Repository from "./Repository";

export default {
    one(payload) {
        return Repository.post('/getSubcription', payload);
    },
    get() {
        return Repository.get(`/getTestPricings`);
    },
    create(payload) {
        return Repository.post(`/createTestSubscription`, payload);
    },
    reSubscribe(payload) {
        console.log(payload);
        return Repository.post(`/TestreSubscribe`, payload);
    },
    checkSubscription(payload) {
        return Repository.post(`/getSubcription`, { sub_id: payload });
    },
    unSubscribe(payload) {
        return Repository.post("/deleteTestSubscription", {
            subscribe_id: payload,
        });
    },
};
